import { Component, Input, OnChanges } from '@angular/core';
import { RetentionPolicyChip, RetentionPolicyDetails } from '@app/shared/models/retention-policy';
import { FileUploadStatus } from "@shared/constants/file-manager/file-upload-status";

@Component({
  selector: 'app-retention-policy-chip',
  templateUrl: './retention-policy-chip.component.html',
  styleUrls: ['./retention-policy-chip.component.css']
})
export class RetentionPolicyChipComponent implements OnChanges {
  @Input({ required: true }) retentionPolicy?: RetentionPolicyChip;

  protected readonly uploadStatus = FileUploadStatus;
  expiration: string | undefined;
  alternativeText: string | undefined;
  expired: boolean = false;
  protected readonly suffix: string = "Expiring";
  currentDate: Date = new Date();
  threshold: Date = new Date();

  ngOnChanges(): void {
    if (this.retentionPolicy) {
      const { type, date, nonExpiringText } = this.retentionPolicy;
      const policyDetails = RetentionPolicyDetails[type];

      if (!policyDetails) {
        return;
      }

      this.currentDate = this.getTodayUtc();

      const { expirationMonths, thresholdDays } = policyDetails;
      const expirationDate = this.getExpirationDate(new Date(date), expirationMonths);
      expirationDate.setHours(0, 0, 0, 0);

      this.currentDate.setHours(this.currentDate.getHours() + this.currentDate.getTimezoneOffset() / 60);
      this.threshold = new Date(this.currentDate);
      this.threshold.setDate(this.currentDate.getUTCDate() + thresholdDays);
      this.threshold.setHours(0, 0, 0, 0);


      if (!this.isExpiringSoon(expirationDate, this.threshold)) {
        if (nonExpiringText) {
          this.alternativeText = nonExpiringText;
        }
        return;
      }

      if (expirationDate.getDay() !== 0) {
        expirationDate.setDate(expirationDate.getDate() + this.getNextSundayDays(expirationDate));
      }
      this.expiration = expirationDate.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short'
      });

      if (this.isExpired(expirationDate, this.currentDate)) {
        this.expired = true;
        this.expiration = "Expired";
      }
    }
  }

  private isExpired(expirationDate: Date, currentDate: Date): boolean {
    if (expirationDate.getDay() === 0) {
      return new Date(currentDate) >= new Date(expirationDate);
    }
    return new Date(currentDate.getUTCDate()) > new Date(expirationDate.getUTCDate());
  }

  private isExpiringSoon(expirationDate: Date, threshold: Date): boolean {
    threshold.setHours(23, 59, 59, 999);
    return new Date(expirationDate.getTime()) <= new Date(threshold.getTime());
  }

  private getExpirationDate(inputDate: Date, expirationMonths: number): Date {
    const expirationDate = new Date(inputDate);
    expirationDate.setMonth(expirationDate.getMonth() + expirationMonths);
    expirationDate.setDate(expirationDate.getDate());
    return expirationDate;
  }

  private getNextSundayDays(inputDate: Date): number {
    const nextSunday = new Date(inputDate);
    const dayOfWeek = nextSunday.getDay();
    return (7 - dayOfWeek) % 7 || 7;
  }

  private getTodayUtc(): Date {
  const now = new Date();
  return new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, 0, 0));
}
}
